// import React from 'react';
// import { LayoutGrid, ShieldCheck, DollarSign, Headset, Laptop } from 'lucide-react';
// import importImage from "../../utils/images/importImage";
// import { useLanguage } from "../../contexts/LanguageContext";

// // Import image at the top level
// const FirstImage = importImage("seller-bg.jpg");
// const WhyChooseImg = importImage("why_choose.jpg");
// // Mock data to demonstrate the new structure.

// const WhyChoose = () => {
//   const { t } = useLanguage();
//   const homeData = {
//   whyChooseTitle: t('whychooseus.title', 'Title'),
//   whyChooseUs: [
//     {
//       title: t('whychooseus.heading1', 'Title'),
//       description: t('whychooseus.detail1', 'Title'),
//       icon: <LayoutGrid className="text-white h-10 w-10" />,
//     },
//     {
//       title: t('whychooseus.heading2', 'Title'),
//       description: t('whychooseus.detail2', 'Title'),
//       icon: <ShieldCheck className="text-white h-10 w-10" />,
//     },
//     {
//       title: t('whychooseus.heading3', 'Title'),
//       description: t('whychooseus.detail3', 'Title'),
//       icon: <DollarSign className="text-white h-10 w-10" />,
//     },
//     {
//       title: t('whychooseus.heading4', 'Title'),
//       description: t('whychooseus.detail4', 'Title'),
//       icon: <Headset className="text-white h-10 w-10" />,
//     },
//     {
//       title: t('whychooseus.heading5', 'Title'),
//       description: t('whychooseus.detail5', 'Title'),
//       icon: <Laptop className="text-white h-10 w-10" />,
//     },
//   ],
//   whyChooseImage: WhyChooseImg,
// };


//   return (
//     <section className="bg-light py-5 py-sm-5 py-md-5 py-lg-5 font-sans">
//       <div className="container">

//         {/* Header section */}
//         <div className="text-center mb-5">
//           <h2 className="fs-1 fw-bold text-dark mb-3">
//             {homeData.whyChooseTitle}
//           </h2>
//         </div>

//         {/* Main content grid */}
//         <div className="row g-5 align-items-stretch"> {/* Changed from align-items-center to align-items-stretch */}

//           {/* Left side: Points list */}
//           <div className="col-lg-6">
//             <div className="d-flex flex-column gap-4 h-100">
//               {homeData.whyChooseUs.map((item, index) => (
//                 <div 
//                   key={index}
//                   className="card p-4 rounded-4 shadow-sm border-0 transition-transform duration-300 hover:shadow-lg h-100"
//                   data-aos="fade-right"
//                   data-aos-delay={index * 150}
//                 >
//                   <div className="d-flex align-items-start h-100">
//                     <div className="p-3 bg-primary bg-opacity-10 text-primary rounded-3 flex-shrink-0 me-4">
//                       {item.icon}
//                     </div>
//                     <div>
//                       <h3 className="h5 fw-bold text-dark">
//                         {item.title}
//                       </h3>
//                       <p className="text-dark mb-0">
//                         {item.description}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Right side: Image section */}
//           <div className="col-lg-6">
//             <div className="h-100 w-100 position-relative rounded-4 overflow-hidden shadow-lg">
//               <img
//                 className="w-100 h-100 object-fit-cover"
//                 src={homeData.whyChooseImage}
//                 alt="A person holding a tablet showing digital security"
//                 onError={(e) => {
//                   e.target.onerror = null;
//                   e.target.src = FirstImage;
//                 }}
//                 style={{
//                   objectPosition: 'center',
//                   minHeight: '100%'
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyChoose;


// import React, { useRef, useEffect, useState } from 'react';
// import { LayoutGrid, ShieldCheck, DollarSign, Headset, Laptop } from 'lucide-react';
// import importImage from "../../utils/images/importImage";
// import { useLanguage } from "../../contexts/LanguageContext";
// import './WhyChoose.css';

// const FirstImage = importImage("seller-bg.jpg");
// const bgImg = importImage("IMG-6.png")
// const Img1 = importImage("why_choose.jpg");
// const Img2 = importImage("trade.jpg");
// const Img3 = importImage("seller-bg.jpg");

// const WhyChoose = () => {
//   const { t } = useLanguage();
//   const parentRef = useRef(null);
//   const [parentHeight, setParentHeight] = useState(0);

//   const homeData = {
//     whyChooseTitle: t('whychooseus.title', 'Title'),
//     whyChooseUs: [
//       { title: t('whychooseus.heading1'), description: t('whychooseus.detail1'), icon: <LayoutGrid className="text-white h-10 w-10" /> },
//       { title: t('whychooseus.heading2'), description: t('whychooseus.detail2'), icon: <ShieldCheck className="text-white h-10 w-10" /> },
//       { title: t('whychooseus.heading3'), description: t('whychooseus.detail3'), icon: <DollarSign className="text-white h-10 w-10" /> },
//       { title: t('whychooseus.heading4'), description: t('whychooseus.detail4'), icon: <Headset className="text-white h-10 w-10" /> },
//       { title: t('whychooseus.heading5'), description: t('whychooseus.detail5'), icon: <Laptop className="text-white h-10 w-10" /> },
//     ],
//     whyChooseImages: [Img1, Img2, Img3],
//   };

//   // Match left container height to right cards
//   useEffect(() => {
//     const updateHeight = () => {
//       if (parentRef.current) {
//         setParentHeight(parentRef.current.offsetHeight);
//       }
//     };
//     updateHeight();
//     window.addEventListener('resize', updateHeight);
//     return () => window.removeEventListener('resize', updateHeight);
//   }, []);

//   return (
//     <section className="why-choose-section">
//       <div className="container">
//         <div className="text-center mb-5">
//           <h2 className="why-choose-section__title" style={{ color: '#000000' }}>{homeData.whyChooseTitle}</h2>
//         </div>

//         <div className="why-choose-parent d-flex flex-wrap gap-100" ref={parentRef}>
//           {/* Left: Images */}
//           <div className="why-choose-left" style={{ height: parentHeight }}>
//             <div className="why-choose-images-section">
//               <img
//                 src={Img1}
//                 alt="Why choose us 1"
//                 className="why-choose-stagger-img img-shadow img-1"
//                 onError={(e) => { e.target.onerror = null; e.target.src = FirstImage; }}
//               />
//               <img
//                 src={Img2}
//                 alt="Why choose us 2"
//                 className="why-choose-stagger-img img-shadow img-2"
//                 onError={(e) => { e.target.onerror = null; e.target.src = FirstImage; }}
//               />
//               <img
//                 src={Img3}
//                 alt="Why choose us 3"
//                 className="why-choose-stagger-img img-shadow img-3"
//                 onError={(e) => { e.target.onerror = null; e.target.src = FirstImage; }}
//               />
//             </div>
//           </div>

//           {/* Right: Cards */}
//           <div className="why-choose-right d-flex flex-column gap-4">
//             {homeData.whyChooseUs.map((item, index) => (
//               <div key={index} className="why-choose-card card p-4 rounded-4 shadow-sm border-start border-4 border-primary" data-aos="fade-left" data-aos-delay={index * 150}>
//                 <div className="d-flex align-items-start">
//                  <div className="p-3 bg-primary bg-opacity-10 text-primary rounded-3 flex-shrink-0 me-4">
//                      {item.icon}
//                     </div>
//                   <div>
//                     <h3 className="h5 fw-bold text-dark">{item.title}</h3>
//                     <p className="text-dark mb-0">{item.description}</p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyChoose;

// import React from "react";
// import { LayoutGrid, ShieldCheck, DollarSign, Headset, Laptop } from "lucide-react";
// import importImage from "../../utils/images/importImage";
// import { useLanguage } from "../../contexts/LanguageContext";
// import "./WhyChoose.css";

// const FirstImage = importImage("seller-bg.jpg");
// const bgImg = importImage("IMG-6.png");

// const WhyChoose = () => {
//   const { t } = useLanguage();

//   const homeData = {
//     whyChooseTitle: t("whychooseus.title"),
//     whyChooseUs: [
//       {
//         title: t("whychooseus.heading1"),
//         description: t("whychooseus.detail1"),
//         icon: <LayoutGrid className="text-white" size={24} />,
//       },
//       {
//         title: t("whychooseus.heading2"),
//         description: t("whychooseus.detail2"),
//         icon: <ShieldCheck className="text-white" size={24} />,
//       },
//       {
//         title: t("whychooseus.heading3"),
//         description: t("whychooseus.detail3"),
//         icon: <DollarSign className="text-white" size={24} />,
//       },
//       {
//         title: t("whychooseus.heading4"),
//         description: t("whychooseus.detail4"),
//         icon: <Headset className="text-white" size={24} />,
//       },
//       {
//         title: t("whychooseus.heading5"),
//         description: t("whychooseus.detail5"),
//         icon: <Laptop className="text-white" size={24} />,
//       },
//     ],
//   };

//   return (
//     <section className="why-choose-section py-5">
//       <div className="container">
//         {/* Title */}
//         <div className="text-center mb-5">
//           <h2 className="fw-bold">{homeData.whyChooseTitle}</h2>
//         </div>

//         {/* Main Layout */}
//         <div className="row align-items-stretch">

//           {/* LEFT: IMAGE */}
//           <div className="col-lg-6 mb-4 mb-lg-0">
//             <div className="why-choose-image-wrapper">
//               <img
//                 src={bgImg}
//                 alt="Why choose us"
//                 className="why-choose-main-img"
//                 onError={(e) => {
//                   e.target.onerror = null;
//                   e.target.src = FirstImage;
//                 }}
//               />
//             </div>
//           </div>

//           {/* RIGHT: CARDS */}
//           <div className="col-lg-6">
//             <div className="d-flex flex-column gap-4">

//               {homeData.whyChooseUs.map((item, index) => (
//                 <div
//                   key={index}
//                   className="why-choose-card card p-4 rounded-4 shadow-sm border-start border-4 border-primary"
//                   data-aos="fade-left"
//                   data-aos-delay={index * 150}
//                 >
//                   <div className="d-flex align-items-start">
                    
//                     <div className="icon-box me-4">
//                       {item.icon}
//                     </div>

//                     <div>
//                       <h5 className="fw-bold mb-2">{item.title}</h5>
//                       <p className="mb-0 text-muted">{item.description}</p>
//                     </div>

//                   </div>
//                 </div>
//               ))}

//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyChoose;

// lovable code 
// import React, { useRef, useEffect, useState } from 'react';
// import { LayoutGrid, ShieldCheck, DollarSign, Headset, Laptop } from 'lucide-react';
// import whyChooseImg1 from "../../assets/images/IMG-1.png";
// import whyChooseImg2 from "../../assets/images/IMG22.jpg";
// import whyChooseImg3 from "../../assets/images/why_choose.jpg";

// // import whyChooseImg1 from "../../assets/images/img1.png";
// // import whyChooseImg2 from "../../assets/images/img3.png";
// // import whyChooseImg3 from "../../assets/images/img2.png";
// import './WhyChoose.css';

// const WhyChoose = () => {

//   const parentRef = useRef(null); // ✅ removed TypeScript generic
//   const [parentHeight, setParentHeight] = useState(0);

//   const whyChooseTitle = "WHY choose us...";

//   const whyChooseUs = [
//     {
//       title: "Wide Product Range",
//       description: "From cotton to polyester, recycled yarn to specialty blends.",
//       icon: <LayoutGrid className="why-choose-icon" />,
//     },
//     {
//       title: "Verified Suppliers",
//       description: "Every supplier on our platform is pre-screened for quality and reliability.",
//       icon: <ShieldCheck className="why-choose-icon" />,
//     },
//     {
//       title: "Competitive Pricing",
//       description: "We leverage bulk buying and transparent dealing to offer the best rates.",
//       icon: <DollarSign className="why-choose-icon" />,
//     },
//     {
//       title: "Customer-Centric Support",
//       description: "Our team is here to assist you at every step.",
//       icon: <Headset className="why-choose-icon" />,
//     },
//     {
//       title: "Technology-Driven",
//       description:
//         "Experience a modern, easy to use platform with smart filters, order tracking, and fast communication tools.",
//       icon: <Laptop className="why-choose-icon" />,
//     },
//   ];

//   const whyChooseImages = [whyChooseImg1, whyChooseImg2, whyChooseImg3];

//   useEffect(() => {
//     const updateHeight = () => {
//       if (parentRef.current) {
//         setParentHeight(parentRef.current.offsetHeight);
//       }
//     };

//     updateHeight();
//     window.addEventListener('resize', updateHeight);

//     return () => {
//       window.removeEventListener('resize', updateHeight);
//     };
//   }, []);

//   return (
//     <section className="why-choose-section">
//       <div className="container">
//         <div className="why-choose-header">
//           <h2 className="why-choose-section__title">{whyChooseTitle}</h2>
//         </div>

//         <div className="why-choose-parent" ref={parentRef}>
          
//           {/* Left: Images */}
//           <div
//             className="why-choose-left"
//             style={{ height: parentHeight || "auto" }}
//           >
//             <div className="why-choose-images-section">
//               <img
//                 src={whyChooseImages[0]}
//                 alt="Why choose us 1"
//                 className="why-choose-stagger-img img-shadow img-1"
//               />
//               <img
//                 src={whyChooseImages[1]}
//                 alt="Why choose us 2"
//                 className="why-choose-stagger-img img-shadow img-2"
//               />
//               <img
//                 src={whyChooseImages[2]}
//                 alt="Why choose us 3"
//                 className="why-choose-stagger-img img-shadow img-3"
//               />
//             </div>
//           </div>

//           {/* Right: Cards */}
//           <div className="why-choose-right">
//             {whyChooseUs.map((item, index) => (
//               <div key={index} className="why-choose-card border-start border-4 border-primary">
//                 <div className="why-choose-card__inner">
//                   <div className="why-choose-card__icon-wrapper">
//                     {item.icon}
//                   </div>
//                   <div className="why-choose-card__content">
//                     <h3 className="why-choose-card__title">{item.title}</h3>
//                     <p className="why-choose-card__description">
//                       {item.description}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyChoose;

import React, { useRef, useEffect, useState } from "react";
import { LayoutGrid, ShieldCheck, DollarSign, Headset, Laptop } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

import whyChooseImg1 from "../../assets/images/IMG-1.png";
import whyChooseImg2 from "../../assets/images/IMG22.jpg";
import whyChooseImg3 from "../../assets/images/why_choose.jpg";

import "./WhyChoose.css";

const icons = [
  <LayoutGrid className="why-choose-icon" />,
  <ShieldCheck className="why-choose-icon" />,
  <DollarSign className="why-choose-icon" />,
  <Headset className="why-choose-icon" />,
  <Laptop className="why-choose-icon" />,
];

const whyChooseImages = [
  whyChooseImg1,
  whyChooseImg2,
  whyChooseImg3,
];

const WhyChoose = () => {
  const { t } = useLanguage();

  const parentRef = useRef(null);
  const [parentHeight, setParentHeight] = useState(0);

  // ✅ get translated items
  const whyChooseUs = t("whychooseus.items", {
    returnObjects: true,
  });

  useEffect(() => {
    const updateHeight = () => {
      if (parentRef.current) {
        setParentHeight(parentRef.current.offsetHeight);
      }
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <section className="why-choose-section">
      <div className="container">
        <div className="why-choose-header">
          <h2 className="why-choose-section__title">
            {t("whychooseus.title")}
          </h2>
        </div>

        <div className="why-choose-parent" ref={parentRef}>

          {/* LEFT IMAGES */}
          <div
            className="why-choose-left"
            style={{ height: parentHeight || "auto" }}
          >
            <div className="why-choose-images-section">
              {whyChooseImages.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`why choose ${i}`}
                  className={`why-choose-stagger-img img-shadow img-${i + 1}`}
                />
              ))}
            </div>
          </div>

          {/* RIGHT CARDS */}
          <div className="why-choose-right">
            {whyChooseUs.map((item, index) => (
              <div
                key={index}
                className="why-choose-card border-start border-4 border-primary"
              >
                <div className="why-choose-card__inner">
                  <div className="why-choose-card__icon-wrapper">
                    {icons[index]}
                  </div>

                  <div className="why-choose-card__content">
                    <h3 className="why-choose-card__title">
                      {item.title}
                    </h3>

                    <p className="why-choose-card__description">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyChoose;